import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import {
    CarrierLane,
    EquipmentClass,
    Mode,
    SearchModeEquipmentClassTrailerType,
    TrailerType
} from '../../models/models';

@Component({
    selector: 'carrier-lane-form',
    templateUrl: './carrier-lane-form.component.html',
    standalone: false
})
export class CarrierLaneForm implements OnChanges {
    @Input() carrierLaneID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public carrierLane: CarrierLane = {} as CarrierLane;
    public modeList: Mode[] = [];
    public equipmentClassList: EquipmentClass[] = [];
    public trailerTypeList: TrailerType[] = [];
    public modeEquipmentClassTrailerTypeList: SearchModeEquipmentClassTrailerType[] = [];
    public modeID: number = 0;
    public equipmentClassID: number = 0;
    public trailerTypeID: number = 0;
    public isLoading: boolean = false;

    constructor(private cseService: CSEService, private notificationService: NotificationService,
        private orderService: OrderService) {
    }

    ngOnInit() {
        //this.getSearchModeEquipmentClassTrailerTypes();
        //console.log("ngOnInit", this.opportunityID, this.carrierID);
    }

    ngOnChanges() {
        this.getCarrierLane();
        //console.log("ngOnChanges", this.opportunity);
    }

    private getCarrierLane() {
        this.isLoading = true;
        this.cseService.getCarrierLaneByID(this.carrierLaneID).subscribe(result => {
            this.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.carrierLane = result.resultCollection[0];
            }
        });
    }

    private getSearchModeEquipmentClassTrailerTypes() {
        this.orderService.getAllSearchModeEquipmentClassTrailerType().subscribe(result => {
            this.modeEquipmentClassTrailerTypeList = result.resultCollection;
            this.getModes();
            //this.setDefaults();
        });
    }

    private getModes() {
        //this.orderService.getModes().subscribe(result => {
        //    this.modeList = result;
        //});

        for (var i = 0; i < this.modeEquipmentClassTrailerTypeList.length; i++) {
            var idx = this.modeList.findIndex(t => t.modeID == this.modeEquipmentClassTrailerTypeList[i].modeID);
            if (idx < 0) {
                var mode: Mode = {
                    modeID: this.modeEquipmentClassTrailerTypeList[i].modeID,
                    abbrev: this.modeEquipmentClassTrailerTypeList[i].modeAbbrev,
                    description: this.modeEquipmentClassTrailerTypeList[i].modeDescription,
                    groupEmail: "",
                    defaultTrailerTypeId: 0,
                    includeInLogisticLaneInd: false,
                    sortOrder: this.modeEquipmentClassTrailerTypeList[i].modeSortOrder
                }
                this.modeList.push(mode);
                this.modeList = this.modeList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    private getEquipmentClasses() {
        //this.orderService.getEquipmentClasses().subscribe(result => {
        //    this.equipmentClassList = result.resultCollection;
        //});

        var subList = this.modeEquipmentClassTrailerTypeList.filter(t => t.modeID == this.modeID);
        for (var i = 0; i < subList.length; i++) {
            var idx = this.equipmentClassList.findIndex(t => t.equipmentClassID == subList[i].equipmentClassID);
            if (idx < 0) {
                var equipmentClass: EquipmentClass = {
                    equipmentClassID: subList[i].equipmentClassID,
                    abbreviation: subList[i].equipmentClassAbbrev,
                    className: subList[i].equipmentClassName,
                    sortOrder: subList[i].equipmentClassSortOrder,
                    greenScreensTransportType: "",
                    convoyEquipmentType: ""
                }
                this.equipmentClassList.push(equipmentClass);
                this.equipmentClassList = this.equipmentClassList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    private getTrailerTypes() {
        //this.orderService.getTrailerTypes().subscribe(result => {
        //    this.trailerTypeList = result;
        //});

        var subList = this.modeEquipmentClassTrailerTypeList.filter(t => t.modeID == this.modeID && t.equipmentClassID == this.equipmentClassID && t.allowedOnLanes == true);
        for (var i = 0; i < subList.length; i++) {
            var idx = this.trailerTypeList.findIndex(t => t.trailerTypeID == subList[i].trailerTypeID);
            if (idx < 0) {
                var trailerType: TrailerType = {
                    trailerTypeID: subList[i].trailerTypeID,
                    abbrev: subList[i].trailerTypeAbbrev,
                    description: subList[i].trailerTypeDescription,
                    defaultModeID: subList[i].defaultModeID!,
                    allowedOnLanes: subList[i].allowedOnLanes!,
                    defaultLength: subList[i].defaultLength,
                    defaultWeight: subList[i].defaultWeight,
                    datEquipmentCode: "",
                    datEquipmentTypeId: 0,
                    erpCode: "",
                    includeInLogisticLaneInd: false,
                    sortOrder: subList[i].trailerTypeSortOrder
                }
                this.trailerTypeList.push(trailerType);
                this.trailerTypeList = this.trailerTypeList.sort((left, right): number => {
                    if (left.sortOrder < right.sortOrder) return -1;
                    if (left.sortOrder > right.sortOrder) return 1;
                    return 0;
                });
            }
        }
    }

    public modeChanged(evt: any) {
        var modeID = evt.target ? evt.target.value : evt;

        if (modeID > 0) {
            var mode = this.modeList.filter(t => t.modeID == modeID);
            if (mode != null && mode.length > 0) {
                var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == mode[0].defaultTrailerTypeId);

                if (trailerType != null && trailerType.length > 0) {
                    this.trailerTypeID = trailerType[0].trailerTypeID;
                }
            }
            else {
                this.trailerTypeID = 0;
            }
        } else {
            this.trailerTypeID = 0;
        }

        this.equipmentClassID = 0;
        this.trailerTypeID = 0;
        this.equipmentClassList.length = 0;
        this.trailerTypeList.length = 0;

        this.getEquipmentClasses();
        this.getTrailerTypes();
    }

    public equipmentClassChanged(evt: any) {
        var classID = evt.target ? evt.target.value : evt;

        if (classID > 0) {
            var equipmentClass = this.equipmentClassList.filter(t => t.equipmentClassID == classID);
            if (equipmentClass != null && equipmentClass.length > 0) {
            }
            else {
                this.equipmentClassID = 0;
            }
        } else {
            this.equipmentClassID = 0;
        }

        this.trailerTypeID = 0;
        this.trailerTypeList.length = 0;

        this.getTrailerTypes();
    }

    public trailerTypeChanged(evt: any) {
        var trailerTypeID = evt.target ? evt.target.value : evt;

        if (trailerTypeID > 0) {
            var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == trailerTypeID);
            if (trailerType != null && trailerType.length > 0) {
            }
            else {
                this.trailerTypeID = 0;
            }
        } else {
            this.trailerTypeID = 0;
        }
    }

    public save() {
        this.isLoading = true;
        console.log("save:before", this.carrierLane);
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.carrierLane.modifiedByEmployeeID = employeeID;
        if (this.carrierLane.ratePerMile == null) {
            this.carrierLane.ratePerMile = 0;
        }
        this.cseService.saveCarrierLane(this.carrierLane).subscribe(result => {
            this.isLoading = false;
            console.log("save:after", result);
            this.onRefresh.emit();
        });

        this.carrierLane = {} as CarrierLane;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
